import { render, staticRenderFns } from "./address-list.vue?vue&type=template&id=ffdbfcaa&scoped=true&"
import script from "./address-list.vue?vue&type=script&lang=js&"
export * from "./address-list.vue?vue&type=script&lang=js&"
import style0 from "./address-list.vue?vue&type=style&index=0&id=ffdbfcaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffdbfcaa",
  null
  
)

export default component.exports